import { render, staticRenderFns } from "./hurry-box.vue?vue&type=template&id=308df8e5&"
import script from "./hurry-box.vue?vue&type=script&lang=js&"
export * from "./hurry-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports